import { render, staticRenderFns } from "./DatasetChartDetail.vue?vue&type=template&id=51d638a7&scoped=true"
import script from "./DatasetChartDetail.vue?vue&type=script&lang=js"
export * from "./DatasetChartDetail.vue?vue&type=script&lang=js"
import style0 from "./DatasetChartDetail.vue?vue&type=style&index=0&id=51d638a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d638a7",
  null
  
)

export default component.exports